module.exports = __webpack_public_path__ + "c2f38953.svg";